/* eslint-disable no-param-reassign */
import { Path } from 'slate';
import { DreamWithOverride } from '../../plate';

export const withSlashCommand: DreamWithOverride = (editor) => {
  const { apply } = editor;

  editor.apply = (op) => {
    apply(op);

    // slash command is already closed
    if (!editor.store.getState().isSlashCommandOpen) return;

    // close slash command when doing operation other than set_selection with condition below
    // or insert_text or remove_text
    if (
      !(
        op.type === 'set_selection'
        && op.properties?.focus?.path
        && op.newProperties?.focus?.path
        && Path.equals(op.properties.focus.path, op.newProperties.focus.path)
      )
      && !['insert_text', 'remove_text'].includes(op.type)
    ) {
      editor.store.setState({
        isSlashCommandOpen: false,
        slashCommandOptions: [],
      });
    }
  };

  return editor;
};
